import Main from "./main";
import { withRouter } from "react-router-dom";

export default withRouter(Main);
